import React, { useEffect, useRef } from "react";


// Reusable Counter Component
const FactCounter = ({ value, title }) => {
  const counterRef = useRef(null);
  const observerRef = useRef(null);

  useEffect(() => {
   

    const animateCounter = (el) => {
      const from = 0;
      const to = parseInt(el.getAttribute("data-to-value")) || 0;
      const duration = parseInt(el.getAttribute("data-duration")) || 3000;
      const delimiter = el.getAttribute("data-delimiter") || "";

      let start = null;

      const step = (timestamp) => {
        if (!start) start = timestamp;
        const progress = Math.min((timestamp - start) / duration, 1);
        const current = Math.floor(progress * (to - from) + from);
        el.textContent = delimiter ? current.toLocaleString() : current;
        if (progress < 1) requestAnimationFrame(step);
      };

      requestAnimationFrame(step);
    };

    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !entry.target.classList.contains("counted")) {
            animateCounter(entry.target);
            entry.target.classList.add("counted");
          }
        });
      },
      { threshold: 0.5 }
    );

    if (counterRef.current) observerRef.current.observe(counterRef.current);

    return () => {
      if (observerRef.current && counterRef.current)
        observerRef.current.unobserve(counterRef.current);
    };
  }, []);

  return (
    <div className="fact-single-item">
      <div className="fact-single-wrapper">
        <div className="fact-counter">
          <div className="fact-counter-number-wrapper">
            <span ref={counterRef}
              className="fact-counter-number"
              data-duration="3000"
              data-to-value={value}
              data-from-value="0"
              data-delimiter=","
            >
              0
            </span>
            <span className="fact-counter-number-suffix">+</span>
          </div>
          <div className="fact-counter-title">{title}</div>
        </div>
      </div>
    </div>
  );
};

// ✅ Main Eligibility Section
const Eligibility = ({ eligibilitySection }) => {
  if (!eligibilitySection) return null;

  const { title, intro_text, counters = [] } = eligibilitySection;

  return (
    <section className="py-3" style={{ background: "aliceblue" }}>
      <div className="container">
        <div
          className="sec-title text-center"
       
        >
          <h2>{title}</h2>
        </div>

        <div className="row " >
          <p className="mb-3" style={{ textAlign: "justify" }}>
            {intro_text}
          </p>
        </div>

        <div className="row">
          {counters.map((counter, index) => (
            <div
              key={index}
              id="mobile-center"
              className={`${index < 4 ? "col-md-3" : "col-md-4"} mb-3`}
              
            >
              <FactCounter value={counter.value} title={counter.title} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Eligibility;
